export const ICONS = [
  "icon-park-solid:app-switch",
  "icon-park-solid:application-one",
  "icon-park-solid:asterisk",
  "icon-park-solid:badge",
  "icon-park-solid:benz",
  "icon-park-solid:blocks-and-arrows",
  "icon-park-solid:category-management",
  "icon-park-solid:circle-five-line",
  "icon-park-solid:circle-four",
  "icon-park-solid:circle-four-line",
  "icon-park-solid:circle-three",
  "icon-park-solid:circle-two-line",
  "icon-park-solid:circles-and-triangles",
  "icon-park-solid:circles-seven",
  "icon-park-solid:circular-connection",
  "icon-park-solid:cones",
  "icon-park-solid:converging-gateway",
  "icon-park-solid:coordinate-system",
  "icon-park-solid:cross-ring",
  "icon-park-solid:crown-two",
  "icon-park-solid:cube-four",
  "icon-park-solid:cycle-one",
  "icon-park-solid:cylinder",
  "icon-park-solid:display",
  "icon-park-solid:exclusive-gateway",
  "icon-park-solid:figma-component",
  "icon-park-solid:four-arrows",
  "icon-park-solid:four-point-connection",
  "icon-park-solid:four-round-point-connection",
  "icon-park-solid:game-emoji",
  "icon-park-solid:graphic-design",
  "icon-park-solid:graphic-design-two",
  "icon-park-solid:graphic-stitching-four",
  "icon-park-solid:graphic-stitching-three",
  "icon-park-solid:halo",
  "icon-park-solid:hexagon-strip",
  "icon-park-solid:inclusive-gateway",
  "icon-park-solid:keyline",
  "icon-park-solid:multi-circular",
  "icon-park-solid:multi-rectangle",
  "icon-park-solid:multi-triangular-two",
  "icon-park-solid:nested-arrows",
  "icon-park-solid:nine-points-connected",
  "icon-park-solid:one-third-rotation",
  "icon-park-solid:open-one",
  "icon-park-solid:outbound",
  "icon-park-solid:parallel-gateway",
  "icon-park-solid:rectangle-tear",
  "icon-park-solid:rectangle-x",
  "icon-park-solid:rectangular-circular-connection",
  "icon-park-solid:rectangular-circular-separation",
  "icon-park-solid:refraction",
  "icon-park-solid:reverse-operation-in",
  "icon-park-solid:reverse-operation-out",
  "icon-park-solid:right-run",
  "icon-park-solid:round-caliper",
  "icon-park-solid:round-mask",
  "icon-park-solid:run-left",
  "icon-park-solid:sales-report",
  "icon-park-solid:seo",
  "icon-park-solid:six-circular-connection",
  "icon-park-solid:six-points",
  "icon-park-solid:split-branch",
  "icon-park-solid:table-report",
  "icon-park-solid:texture-two",
  "icon-park-solid:three-hexagons",
  "icon-park-solid:three-slashes",
  "icon-park-solid:three-triangles",
  "icon-park-solid:treasure-chest",
  "icon-park-solid:triangle-round-rectangle",
  "icon-park-solid:two-semicircles",
  "icon-park-solid:two-triangles",
  "icon-park-solid:update-rotation",
  "icon-park-solid:warehousing",
  "icon-park-solid:whirlwind",
  "icon-park-solid:bat",
  "icon-park-solid:bear",
  "icon-park-solid:bee",
  "icon-park-solid:bird",
  "icon-park-solid:butterfly",
  "icon-park-solid:cattle",
  "icon-park-solid:deer",
  "icon-park-solid:dog",
  "icon-park-solid:dolphin",
  "icon-park-solid:duck",
  "icon-park-solid:eagle",
  "icon-park-solid:fish-one",
  "icon-park-solid:frog",
  "icon-park-solid:hippo",
  "icon-park-solid:koala-bear",
  "icon-park-solid:monkey",
  "icon-park-solid:owl",
  "icon-park-solid:panda",
  "icon-park-solid:pig",
  "icon-park-solid:pigeon",
  "icon-park-solid:rabbit",
  "icon-park-solid:whale",
  "icon-park-solid:arrow-circle-down",
  "icon-park-solid:arrow-circle-left",
  "icon-park-solid:arrow-circle-right",
  "icon-park-solid:arrow-circle-up",
  "icon-park-solid:circle-double-down",
  "icon-park-solid:circle-double-left",
  "icon-park-solid:circle-double-right",
  "icon-park-solid:circle-double-up",
  "icon-park-solid:circle-left-down",
  "icon-park-solid:circle-left-up",
  "icon-park-solid:circle-right-down",
  "icon-park-solid:circle-right-up",
  "icon-park-solid:down-c",
  "icon-park-solid:down-one",
  "icon-park-solid:down-square",
  "icon-park-solid:down-two",
  "icon-park-solid:download-three",
  "icon-park-solid:incoming",
  "icon-park-solid:install",
  "icon-park-solid:left-c",
  "icon-park-solid:left-one",
  "icon-park-solid:left-square",
  "icon-park-solid:left-two",
  "icon-park-solid:menu-fold-one",
  "icon-park-solid:menu-unfold-one",
  "icon-park-solid:outgoing",
  "icon-park-solid:right-c",
  "icon-park-solid:right-one",
  "icon-park-solid:right-square",
  "icon-park-solid:right-two",
  "icon-park-solid:rotate",
  "icon-park-solid:sliding-horizontal",
  "icon-park-solid:sliding-vertical",
  "icon-park-solid:sort",
  "icon-park-solid:up-c",
  "icon-park-solid:up-one",
  "icon-park-solid:up-square",
  "icon-park-solid:up-two",
  "icon-park-solid:upload",
  "icon-park-solid:upload-three",
  "icon-park-solid:zoom-internal",
  "icon-park-solid:baby-app",
  "icon-park-solid:baby-car-seat",
  "icon-park-solid:baby-feet",
  "icon-park-solid:baby-meal",
  "icon-park-solid:baby-mobile",
  "icon-park-solid:baby-one",
  "icon-park-solid:baby-pants",
  "icon-park-solid:baby-sling",
  "icon-park-solid:baby-taste",
  "icon-park-solid:bib",
  "icon-park-solid:booster-car-seat",
  "icon-park-solid:boy",
  "icon-park-solid:boy-one",
  "icon-park-solid:boy-stroller",
  "icon-park-solid:boy-two",
  "icon-park-solid:breast-pump",
  "icon-park-solid:chair",
  "icon-park-solid:chair-one",
  "icon-park-solid:children-pyramid",
  "icon-park-solid:crying-baby",
  "icon-park-solid:family",
  "icon-park-solid:float",
  "icon-park-solid:girl",
  "icon-park-solid:girl-one",
  "icon-park-solid:girl-two",
  "icon-park-solid:heart-ballon",
  "icon-park-solid:onesies",
  "icon-park-solid:pacifier",
  "icon-park-solid:paper-ship",
  "icon-park-solid:parenting-book",
  "icon-park-solid:party-balloon",
  "icon-park-solid:pokeball-one",
  "icon-park-solid:powder",
  "icon-park-solid:preschool",
  "icon-park-solid:radio-nanny",
  "icon-park-solid:rattle",
  "icon-park-solid:rattle-one",
  "icon-park-solid:rocking-horse",
  "icon-park-solid:romper",
  "icon-park-solid:sippy-cup",
  "icon-park-solid:steoller",
  "icon-park-solid:tire-swing",
  "icon-park-solid:aiming",
  "icon-park-solid:all-application",
  "icon-park-solid:bill",
  "icon-park-solid:bookmark",
  "icon-park-solid:bookmark-one",
  "icon-park-solid:camera",
  "icon-park-solid:config",
  "icon-park-solid:delete-two",
  "icon-park-solid:dislike-two",
  "icon-park-solid:equalizer",
  "icon-park-solid:female",
  "icon-park-solid:home",
  "icon-park-solid:hourglass-full",
  "icon-park-solid:hourglass-null",
  "icon-park-solid:lightning",
  "icon-park-solid:like",
  "icon-park-solid:male",
  "icon-park-solid:more-app",
  "icon-park-solid:more-two",
  "icon-park-solid:pic",
  "icon-park-solid:preview-open",
  "icon-park-solid:rss",
  "icon-park-solid:save",
  "icon-park-solid:save-one",
  "icon-park-solid:search",
  "icon-park-solid:setting",
  "icon-park-solid:setting-one",
  "icon-park-solid:setting-three",
  "icon-park-solid:setting-two",
  "icon-park-solid:sleep",
  "icon-park-solid:system",
  "icon-park-solid:tag",
  "icon-park-solid:tag-one",
  "icon-park-solid:tips",
  "icon-park-solid:tool",
  "icon-park-solid:waterfalls-h",
  "icon-park-solid:waterfalls-v",
  "icon-park-solid:zoom-in",
  "icon-park-solid:zoom-out",
  "icon-park-solid:adobe-illustrate",
  "icon-park-solid:adobe-indesign",
  "icon-park-solid:adobe-lightroom",
  "icon-park-solid:adobe-photoshop",
  "icon-park-solid:android",
  "icon-park-solid:app-store",
  "icon-park-solid:apple",
  "icon-park-solid:browser-safari",
  "icon-park-solid:bydesign",
  "icon-park-solid:bytedance",
  "icon-park-solid:dribble",
  "icon-park-solid:dropbox",
  "icon-park-solid:facebook",
  "icon-park-solid:facetime",
  "icon-park-solid:faceu",
  "icon-park-solid:feelgood",
  "icon-park-solid:feelgood-one",
  "icon-park-solid:figma",
  "icon-park-solid:foursquare",
  "icon-park-solid:friends-circle",
  "icon-park-solid:gitlab",
  "icon-park-solid:google",
  "icon-park-solid:google-ads",
  "icon-park-solid:health",
  "icon-park-solid:html-five",
  "icon-park-solid:instagram",
  "icon-park-solid:instagram-one",
  "icon-park-solid:lincoln",
  "icon-park-solid:maill-one",
  "icon-park-solid:messages",
  "icon-park-solid:messages-one",
  "icon-park-solid:mitsubishi",
  "icon-park-solid:new-dianziqian",
  "icon-park-solid:phone-two",
  "icon-park-solid:qingniao-clue",
  "icon-park-solid:renault",
  "icon-park-solid:sketch",
  "icon-park-solid:tiktok",
  "icon-park-solid:topbuzz",
  "icon-park-solid:tuchong",
  "icon-park-solid:tumblr",
  "icon-park-solid:twitter",
  "icon-park-solid:ulikecam",
  "icon-park-solid:vigo",
  "icon-park-solid:volkswagen",
  "icon-park-solid:wechat",
  "icon-park-solid:weibo",
  "icon-park-solid:windows",
  "icon-park-solid:xiaodu",
  "icon-park-solid:xigua",
  "icon-park-solid:xingfuli",
  "icon-park-solid:youtobe",
  "icon-park-solid:youtube",
  "icon-park-solid:zijinyunying",
  "icon-park-solid:application",
  "icon-park-solid:arc-de-triomphe",
  "icon-park-solid:booth",
  "icon-park-solid:bridge-one",
  "icon-park-solid:building-four",
  "icon-park-solid:building-one",
  "icon-park-solid:building-three",
  "icon-park-solid:building-two",
  "icon-park-solid:castle",
  "icon-park-solid:chimney",
  "icon-park-solid:chinese-pavilion",
  "icon-park-solid:church-one",
  "icon-park-solid:church-two",
  "icon-park-solid:circle-house",
  "icon-park-solid:circus",
  "icon-park-solid:city",
  "icon-park-solid:city-gate",
  "icon-park-solid:city-one",
  "icon-park-solid:clock-tower",
  "icon-park-solid:death-star",
  "icon-park-solid:elevator",
  "icon-park-solid:escalators",
  "icon-park-solid:factory-building",
  "icon-park-solid:ferris-wheel",
  "icon-park-solid:gate",
  "icon-park-solid:green-house",
  "icon-park-solid:home-two",
  "icon-park-solid:hospital-two",
  "icon-park-solid:hotel",
  "icon-park-solid:light-house",
  "icon-park-solid:monument-one",
  "icon-park-solid:monument-two",
  "icon-park-solid:museum-one",
  "icon-park-solid:museum-two",
  "icon-park-solid:nuclear-plant",
  "icon-park-solid:open-door",
  "icon-park-solid:pagoda",
  "icon-park-solid:palace",
  "icon-park-solid:pearl-of-the-orient",
  "icon-park-solid:phone-booth",
  "icon-park-solid:prison",
  "icon-park-solid:pull-door",
  "icon-park-solid:push-door",
  "icon-park-solid:school",
  "icon-park-solid:security-stall",
  "icon-park-solid:shop",
  "icon-park-solid:shopping-mall",
  "icon-park-solid:taj-mahal",
  "icon-park-solid:tower",
  "icon-park-solid:tower-of-babel",
  "icon-park-solid:up-and-down",
  "icon-park-solid:xiaodu-home",
  "icon-park-solid:ad",
  "icon-park-solid:add",
  "icon-park-solid:add-one",
  "icon-park-solid:at-sign",
  "icon-park-solid:attention",
  "icon-park-solid:big-x",
  "icon-park-solid:bitcoin",
  "icon-park-solid:check-one",
  "icon-park-solid:close-one",
  "icon-park-solid:copyright",
  "icon-park-solid:correct",
  "icon-park-solid:division",
  "icon-park-solid:error",
  "icon-park-solid:forbid",
  "icon-park-solid:help",
  "icon-park-solid:info",
  "icon-park-solid:more-three",
  "icon-park-solid:percentage",
  "icon-park-solid:plus-cross",
  "icon-park-solid:reduce",
  "icon-park-solid:reduce-one",
  "icon-park-solid:success",
  "icon-park-solid:trademark",
  "icon-park-solid:vip",
  "icon-park-solid:activity-source",
  "icon-park-solid:analysis",
  "icon-park-solid:area-map",
  "icon-park-solid:broadcast-one",
  "icon-park-solid:bubble-chart",
  "icon-park-solid:change-date-sort",
  "icon-park-solid:chart-graph",
  "icon-park-solid:chart-histogram-two",
  "icon-park-solid:chart-line-area",
  "icon-park-solid:chart-pie",
  "icon-park-solid:chart-proportion",
  "icon-park-solid:chart-ring",
  "icon-park-solid:chart-stock",
  "icon-park-solid:data",
  "icon-park-solid:data-all",
  "icon-park-solid:data-arrival",
  "icon-park-solid:data-four",
  "icon-park-solid:data-one",
  "icon-park-solid:data-screen",
  "icon-park-solid:data-sheet",
  "icon-park-solid:data-three",
  "icon-park-solid:data-two",
  "icon-park-solid:electrocardiogram",
  "icon-park-solid:form",
  "icon-park-solid:maslow-pyramids",
  "icon-park-solid:multicast",
  "icon-park-solid:pie",
  "icon-park-solid:pie-five",
  "icon-park-solid:pie-four",
  "icon-park-solid:pie-one",
  "icon-park-solid:pie-seven",
  "icon-park-solid:pie-six",
  "icon-park-solid:pie-three",
  "icon-park-solid:pie-two",
  "icon-park-solid:pivot-table",
  "icon-park-solid:radar-chart",
  "icon-park-solid:ranking-list",
  "icon-park-solid:recent-views-sort",
  "icon-park-solid:slide",
  "icon-park-solid:slide-two",
  "icon-park-solid:timeline",
  "icon-park-solid:unicast",
  "icon-park-solid:vertical-timeline",
  "icon-park-solid:bachelor-cap",
  "icon-park-solid:bachelor-cap-one",
  "icon-park-solid:bachelor-cap-two",
  "icon-park-solid:backpack",
  "icon-park-solid:baseball-cap",
  "icon-park-solid:basketball-clothes",
  "icon-park-solid:bow",
  "icon-park-solid:briefcase",
  "icon-park-solid:chef-hat",
  "icon-park-solid:children-cap",
  "icon-park-solid:clothes-briefs",
  "icon-park-solid:clothes-gloves",
  "icon-park-solid:clothes-gloves-two",
  "icon-park-solid:clothes-hoodie",
  "icon-park-solid:clothes-pants-short",
  "icon-park-solid:clothes-pants-sweat",
  "icon-park-solid:clothes-skates",
  "icon-park-solid:clothes-turtleneck",
  "icon-park-solid:clothes-windbreaker",
  "icon-park-solid:coat-hanger",
  "icon-park-solid:commuter-bag",
  "icon-park-solid:crown-three",
  "icon-park-solid:diamond-necklace",
  "icon-park-solid:diamond-ring",
  "icon-park-solid:diamonds",
  "icon-park-solid:full-dress-longuette",
  "icon-park-solid:glasses",
  "icon-park-solid:glasses-one",
  "icon-park-solid:handbag",
  "icon-park-solid:hat",
  "icon-park-solid:headwear",
  "icon-park-solid:high-heeled-shoes",
  "icon-park-solid:holy-sword",
  "icon-park-solid:necktie",
  "icon-park-solid:perfume",
  "icon-park-solid:retro-bag",
  "icon-park-solid:short-skirt",
  "icon-park-solid:shorts",
  "icon-park-solid:skates",
  "icon-park-solid:slippers",
  "icon-park-solid:slippers-one",
  "icon-park-solid:sorcerer-hat",
  "icon-park-solid:sun-hat",
  "icon-park-solid:sweater",
  "icon-park-solid:swimsuit",
  "icon-park-solid:t-shirt",
  "icon-park-solid:the-single-shoulder-bag",
  "icon-park-solid:theme",
  "icon-park-solid:three-d-glasses",
  "icon-park-solid:trousers-bell-bottoms",
  "icon-park-solid:trunk",
  "icon-park-solid:vest",
  "icon-park-solid:woolen-hat",
  "icon-park-solid:comment",
  "icon-park-solid:comment-one",
  "icon-park-solid:comments",
  "icon-park-solid:communication",
  "icon-park-solid:message",
  "icon-park-solid:message-emoji",
  "icon-park-solid:message-one",
  "icon-park-solid:message-privacy",
  "icon-park-solid:message-search",
  "icon-park-solid:message-security",
  "icon-park-solid:message-sent",
  "icon-park-solid:online-meeting",
  "icon-park-solid:phone-call",
  "icon-park-solid:phone-incoming",
  "icon-park-solid:phone-incoming-one",
  "icon-park-solid:phone-missed",
  "icon-park-solid:phone-outgoing",
  "icon-park-solid:phone-outgoing-one",
  "icon-park-solid:phone-telephone",
  "icon-park-solid:phone-video-call",
  "icon-park-solid:tips-one",
  "icon-park-solid:topic",
  "icon-park-solid:topic-discussion",
  "icon-park-solid:carousel",
  "icon-park-solid:checklist",
  "icon-park-solid:page-template",
  "icon-park-solid:platte",
  "icon-park-solid:switch-button",
  "icon-park-solid:table-file",
  "icon-park-solid:tree-list",
  "icon-park-solid:anchor",
  "icon-park-solid:anchor-one",
  "icon-park-solid:anchor-round",
  "icon-park-solid:anchor-squre",
  "icon-park-solid:api",
  "icon-park-solid:applet-closed",
  "icon-park-solid:assembly-line",
  "icon-park-solid:bezier-curve",
  "icon-park-solid:branch",
  "icon-park-solid:branch-one",
  "icon-park-solid:branch-two",
  "icon-park-solid:clue",
  "icon-park-solid:command",
  "icon-park-solid:connect",
  "icon-park-solid:connect-address-one",
  "icon-park-solid:connect-address-two",
  "icon-park-solid:connection",
  "icon-park-solid:connection-box",
  "icon-park-solid:connection-point",
  "icon-park-solid:connection-point-two",
  "icon-park-solid:fork",
  "icon-park-solid:network-tree",
  "icon-park-solid:pull-requests",
  "icon-park-solid:relational-graph",
  "icon-park-solid:ring",
  "icon-park-solid:ring-one",
  "icon-park-solid:s-turn-down",
  "icon-park-solid:s-turn-left",
  "icon-park-solid:s-turn-right",
  "icon-park-solid:s-turn-up",
  "icon-park-solid:share-one",
  "icon-park-solid:split-turn-down-left",
  "icon-park-solid:split-turn-down-right",
  "icon-park-solid:tree-diagram",
  "icon-park-solid:u-turn-down",
  "icon-park-solid:u-turn-left",
  "icon-park-solid:u-turn-right",
  "icon-park-solid:u-turn-up",
  "icon-park-solid:whole-site-accelerator",
  "icon-park-solid:cancer",
  "icon-park-solid:capricornus",
  "icon-park-solid:leo",
  "icon-park-solid:taurus",
  "icon-park-solid:data-display",
  "icon-park-solid:data-lock",
  "icon-park-solid:data-switching",
  "icon-park-solid:data-user",
  "icon-park-solid:database-alert",
  "icon-park-solid:database-code",
  "icon-park-solid:database-config",
  "icon-park-solid:database-download",
  "icon-park-solid:database-enter",
  "icon-park-solid:database-fail",
  "icon-park-solid:database-first",
  "icon-park-solid:database-forbid",
  "icon-park-solid:database-lock",
  "icon-park-solid:database-network",
  "icon-park-solid:database-network-point",
  "icon-park-solid:database-point",
  "icon-park-solid:database-position",
  "icon-park-solid:database-power",
  "icon-park-solid:database-proportion",
  "icon-park-solid:database-search",
  "icon-park-solid:database-setting",
  "icon-park-solid:database-success",
  "icon-park-solid:database-sync",
  "icon-park-solid:database-time",
  "icon-park-solid:add-item",
  "icon-park-solid:add-mode",
  "icon-park-solid:add-pic",
  "icon-park-solid:add-subset",
  "icon-park-solid:add-text-two",
  "icon-park-solid:adjacent-item",
  "icon-park-solid:adjustment",
  "icon-park-solid:align-bottom",
  "icon-park-solid:align-bottom-two",
  "icon-park-solid:align-horizontal-center-two",
  "icon-park-solid:align-horizontally",
  "icon-park-solid:align-left",
  "icon-park-solid:align-left-one",
  "icon-park-solid:align-left-two",
  "icon-park-solid:align-right",
  "icon-park-solid:align-right-one",
  "icon-park-solid:align-right-two",
  "icon-park-solid:align-text-both-one",
  "icon-park-solid:align-text-bottom-one",
  "icon-park-solid:align-text-center-one",
  "icon-park-solid:align-text-left-one",
  "icon-park-solid:align-text-middle-one",
  "icon-park-solid:align-text-right-one",
  "icon-park-solid:align-text-top-one",
  "icon-park-solid:align-top",
  "icon-park-solid:align-top-two",
  "icon-park-solid:align-vertical-center-two",
  "icon-park-solid:align-vertically",
  "icon-park-solid:alignment-bottom-center",
  "icon-park-solid:alignment-bottom-left",
  "icon-park-solid:alignment-bottom-right",
  "icon-park-solid:alignment-horizontal-bottom",
  "icon-park-solid:alignment-horizontal-center",
  "icon-park-solid:alignment-horizontal-top",
  "icon-park-solid:alignment-left-bottom",
  "icon-park-solid:alignment-left-center",
  "icon-park-solid:alignment-left-top",
  "icon-park-solid:alignment-right-bottom",
  "icon-park-solid:alignment-right-center",
  "icon-park-solid:alignment-right-top",
  "icon-park-solid:alignment-top-center",
  "icon-park-solid:alignment-top-left",
  "icon-park-solid:alignment-top-right",
  "icon-park-solid:alignment-vertical-center",
  "icon-park-solid:alignment-vertical-left",
  "icon-park-solid:alignment-vertical-right",
  "icon-park-solid:aperture-priority",
  "icon-park-solid:application-two",
  "icon-park-solid:auto-focus",
  "icon-park-solid:back",
  "icon-park-solid:bottom-bar",
  "icon-park-solid:brightness",
  "icon-park-solid:bring-forward",
  "icon-park-solid:bring-to-front",
  "icon-park-solid:bring-to-front-one",
  "icon-park-solid:calendar",
  "icon-park-solid:chart-pie-one",
  "icon-park-solid:checkbox",
  "icon-park-solid:clear",
  "icon-park-solid:clear-format",
  "icon-park-solid:components",
  "icon-park-solid:copy",
  "icon-park-solid:copy-link",
  "icon-park-solid:curve-adjustment",
  "icon-park-solid:cutting-one",
  "icon-park-solid:damage-map",
  "icon-park-solid:dark-mode",
  "icon-park-solid:delete",
  "icon-park-solid:delete-five",
  "icon-park-solid:delete-four",
  "icon-park-solid:delete-mode",
  "icon-park-solid:delete-one",
  "icon-park-solid:delete-themes",
  "icon-park-solid:delete-three",
  "icon-park-solid:difference-set",
  "icon-park-solid:direction",
  "icon-park-solid:direction-adjustment-two",
  "icon-park-solid:distribute-horizontal-spacing",
  "icon-park-solid:distribute-horizontally",
  "icon-park-solid:distribute-vertical-spacing",
  "icon-park-solid:distribute-vertically",
  "icon-park-solid:download-four",
  "icon-park-solid:drop-shadow-down",
  "icon-park-solid:drop-shadow-left",
  "icon-park-solid:drop-shadow-right",
  "icon-park-solid:drop-shadow-up",
  "icon-park-solid:edit",
  "icon-park-solid:edit-movie",
  "icon-park-solid:edit-two",
  "icon-park-solid:editing",
  "icon-park-solid:electric-wave",
  "icon-park-solid:endpoint-displacement",
  "icon-park-solid:enter-the-keyboard",
  "icon-park-solid:equal-ratio",
  "icon-park-solid:excel-one",
  "icon-park-solid:expand-down",
  "icon-park-solid:expand-left",
  "icon-park-solid:expand-right",
  "icon-park-solid:expand-up",
  "icon-park-solid:extend",
  "icon-park-solid:filter",
  "icon-park-solid:find",
  "icon-park-solid:flashlamp",
  "icon-park-solid:flip-horizontally",
  "icon-park-solid:flip-vertically",
  "icon-park-solid:focus",
  "icon-park-solid:focus-one",
  "icon-park-solid:format-brush",
  "icon-park-solid:full-selection",
  "icon-park-solid:group",
  "icon-park-solid:helpcenter",
  "icon-park-solid:high-light",
  "icon-park-solid:horizontal-tidy-up",
  "icon-park-solid:horizontally-centered",
  "icon-park-solid:inner-shadow-bottom-left",
  "icon-park-solid:inner-shadow-bottom-right",
  "icon-park-solid:inner-shadow-down",
  "icon-park-solid:inner-shadow-left",
  "icon-park-solid:inner-shadow-right",
  "icon-park-solid:inner-shadow-top-left",
  "icon-park-solid:inner-shadow-top-right",
  "icon-park-solid:inner-shadow-up",
  "icon-park-solid:intermediate-mode",
  "icon-park-solid:internal-expansion",
  "icon-park-solid:internal-reduction",
  "icon-park-solid:intersection",
  "icon-park-solid:invert-camera",
  "icon-park-solid:key-one",
  "icon-park-solid:key-two",
  "icon-park-solid:layers",
  "icon-park-solid:layout-five",
  "icon-park-solid:layout-four",
  "icon-park-solid:layout-one",
  "icon-park-solid:layout-three",
  "icon-park-solid:layout-two",
  "icon-park-solid:left-bar",
  "icon-park-solid:left-expand",
  "icon-park-solid:lens-alignment",
  "icon-park-solid:list-alphabet",
  "icon-park-solid:list-bottom",
  "icon-park-solid:list-checkbox",
  "icon-park-solid:list-fail",
  "icon-park-solid:list-middle",
  "icon-park-solid:list-one",
  "icon-park-solid:list-success",
  "icon-park-solid:list-top",
  "icon-park-solid:lock",
  "icon-park-solid:lock-one",
  "icon-park-solid:many-to-many",
  "icon-park-solid:margin",
  "icon-park-solid:margin-one",
  "icon-park-solid:mind-mapping",
  "icon-park-solid:minus-the-bottom",
  "icon-park-solid:minus-the-top",
  "icon-park-solid:modify",
  "icon-park-solid:modify-two",
  "icon-park-solid:more-four",
  "icon-park-solid:move-in-one",
  "icon-park-solid:move-one",
  "icon-park-solid:multi-picture-carousel",
  "icon-park-solid:natural-mode",
  "icon-park-solid:newlybuild",
  "icon-park-solid:next",
  "icon-park-solid:no-shooting",
  "icon-park-solid:one-to-many",
  "icon-park-solid:one-to-one",
  "icon-park-solid:overall-reduction",
  "icon-park-solid:paragraph-alphabet",
  "icon-park-solid:paragraph-rectangle",
  "icon-park-solid:paragraph-round",
  "icon-park-solid:paragraph-triangle",
  "icon-park-solid:picture-one",
  "icon-park-solid:pin",
  "icon-park-solid:plan",
  "icon-park-solid:powerpoint",
  "icon-park-solid:pushpin",
  "icon-park-solid:radio-two",
  "icon-park-solid:reduce-two",
  "icon-park-solid:refresh-one",
  "icon-park-solid:repair",
  "icon-park-solid:reverse-lens",
  "icon-park-solid:reverse-lens-one",
  "icon-park-solid:right-bar",
  "icon-park-solid:right-expand",
  "icon-park-solid:rotate-one",
  "icon-park-solid:rotation-one",
  "icon-park-solid:screenshot",
  "icon-park-solid:screenshot-one",
  "icon-park-solid:screenshot-two",
  "icon-park-solid:selected",
  "icon-park-solid:selected-focus",
  "icon-park-solid:send-backward",
  "icon-park-solid:send-to-back",
  "icon-park-solid:share-two",
  "icon-park-solid:shutter-priority",
  "icon-park-solid:split",
  "icon-park-solid:stamp",
  "icon-park-solid:star",
  "icon-park-solid:sum",
  "icon-park-solid:switch-themes",
  "icon-park-solid:text",
  "icon-park-solid:top-bar",
  "icon-park-solid:ungroup",
  "icon-park-solid:unlock",
  "icon-park-solid:unlock-one",
  "icon-park-solid:vertical-tidy-up",
  "icon-park-solid:vertically-centered",
  "icon-park-solid:video-two",
  "icon-park-solid:view-grid-card",
  "icon-park-solid:view-grid-detail",
  "icon-park-solid:view-grid-list",
  "icon-park-solid:viewfinder",
  "icon-park-solid:word",
  "icon-park-solid:write",
  "icon-park-solid:writing-fluently",
  "icon-park-solid:zip",
  "icon-park-solid:angry-face",
  "icon-park-solid:anguished-face",
  "icon-park-solid:astonished-face",
  "icon-park-solid:confounded-face",
  "icon-park-solid:confused-face",
  "icon-park-solid:disappointed-face",
  "icon-park-solid:distraught-face",
  "icon-park-solid:dizzy-face",
  "icon-park-solid:emotion-happy",
  "icon-park-solid:emotion-unhappy",
  "icon-park-solid:expressionless-face",
  "icon-park-solid:face-with-smiling-open-eyes",
  "icon-park-solid:face-without-mouth",
  "icon-park-solid:frowning-face-whit-open-mouth",
  "icon-park-solid:grimacing-face",
  "icon-park-solid:grinning-face",
  "icon-park-solid:grinning-face-with-open-mouth",
  "icon-park-solid:grinning-face-with-squinting-eyes",
  "icon-park-solid:grinning-face-with-tightly-closed-eyes",
  "icon-park-solid:grinning-face-with-tightly-closed-eyes-open-mouth",
  "icon-park-solid:loudly-crying-face",
  "icon-park-solid:loudly-crying-face-whit-open-mouth",
  "icon-park-solid:neutral-face",
  "icon-park-solid:pouting-face",
  "icon-park-solid:relieved-face",
  "icon-park-solid:slightly-frowning-face-whit-open-mouth",
  "icon-park-solid:slightly-smiling-face",
  "icon-park-solid:sly-face-whit-smile",
  "icon-park-solid:smiling-face",
  "icon-park-solid:smiling-face-with-squinting-eyes",
  "icon-park-solid:surprised-face-with-open-big-mouth",
  "icon-park-solid:surprised-face-with-open-mouth",
  "icon-park-solid:upside-down-face",
  "icon-park-solid:weary-face",
  "icon-park-solid:winking-face",
  "icon-park-solid:winking-face-with-open-eyes",
  "icon-park-solid:worried-face",
  "icon-park-solid:battery-empty",
  "icon-park-solid:battery-full",
  "icon-park-solid:battery-working",
  "icon-park-solid:bloom",
  "icon-park-solid:blossom",
  "icon-park-solid:cactus",
  "icon-park-solid:christmas-tree",
  "icon-park-solid:christmas-tree-one",
  "icon-park-solid:coronavirus",
  "icon-park-solid:fire",
  "icon-park-solid:fruiter",
  "icon-park-solid:green-new-energy",
  "icon-park-solid:leaves-one",
  "icon-park-solid:leaves-two",
  "icon-park-solid:lotus",
  "icon-park-solid:outdoor",
  "icon-park-solid:pinwheel",
  "icon-park-solid:sapling",
  "icon-park-solid:seedling",
  "icon-park-solid:tree-one",
  "icon-park-solid:water",
  "icon-park-solid:water-no",
  "icon-park-solid:windmill",
  "icon-park-solid:windmill-two",
  "icon-park-solid:apple-one",
  "icon-park-solid:avocado",
  "icon-park-solid:avocado-one",
  "icon-park-solid:banana",
  "icon-park-solid:barbecue",
  "icon-park-solid:beer",
  "icon-park-solid:beer-mug",
  "icon-park-solid:birthday-cake",
  "icon-park-solid:bottle-one",
  "icon-park-solid:bottle-three",
  "icon-park-solid:bottle-two",
  "icon-park-solid:bowl",
  "icon-park-solid:bowl-one",
  "icon-park-solid:bread",
  "icon-park-solid:bread-machine",
  "icon-park-solid:bread-one",
  "icon-park-solid:cake",
  "icon-park-solid:cake-five",
  "icon-park-solid:cake-four",
  "icon-park-solid:cake-one",
  "icon-park-solid:cake-three",
  "icon-park-solid:candy",
  "icon-park-solid:canned-fruit",
  "icon-park-solid:chafing-dish",
  "icon-park-solid:chafing-dish-one",
  "icon-park-solid:cheese",
  "icon-park-solid:chef-hat-one",
  "icon-park-solid:cherry",
  "icon-park-solid:chicken",
  "icon-park-solid:chicken-leg",
  "icon-park-solid:chili",
  "icon-park-solid:chopping-board",
  "icon-park-solid:cola",
  "icon-park-solid:cook",
  "icon-park-solid:cooking",
  "icon-park-solid:crab",
  "icon-park-solid:cup-one",
  "icon-park-solid:doughnut",
  "icon-park-solid:drink",
  "icon-park-solid:drumstick",
  "icon-park-solid:egg",
  "icon-park-solid:egg-one",
  "icon-park-solid:eggplant",
  "icon-park-solid:fish",
  "icon-park-solid:fork-spoon",
  "icon-park-solid:french-fries",
  "icon-park-solid:glove",
  "icon-park-solid:goblet",
  "icon-park-solid:goblet-cracking",
  "icon-park-solid:goblet-full",
  "icon-park-solid:hamburger",
  "icon-park-solid:hamburger-one",
  "icon-park-solid:honey",
  "icon-park-solid:honey-one",
  "icon-park-solid:hot-pot",
  "icon-park-solid:hot-pot-one",
  "icon-park-solid:icecream",
  "icon-park-solid:icecream-five",
  "icon-park-solid:icecream-four",
  "icon-park-solid:icecream-two",
  "icon-park-solid:juice",
  "icon-park-solid:kettle-one",
  "icon-park-solid:kitchen-knife",
  "icon-park-solid:knife-fork",
  "icon-park-solid:lemon",
  "icon-park-solid:liqueur",
  "icon-park-solid:macadamia-nut",
  "icon-park-solid:measuring-cup",
  "icon-park-solid:milk",
  "icon-park-solid:milk-one",
  "icon-park-solid:noodles",
  "icon-park-solid:nut",
  "icon-park-solid:orange",
  "icon-park-solid:orange-one",
  "icon-park-solid:oven",
  "icon-park-solid:painted-eggshell",
  "icon-park-solid:peach",
  "icon-park-solid:pear",
  "icon-park-solid:peas",
  "icon-park-solid:popcorn",
  "icon-park-solid:popcorn-one",
  "icon-park-solid:pot",
  "icon-park-solid:pumpkin",
  "icon-park-solid:radish",
  "icon-park-solid:radish-one",
  "icon-park-solid:refrigerator",
  "icon-park-solid:rice",
  "icon-park-solid:sandwich",
  "icon-park-solid:sandwich-one",
  "icon-park-solid:scallion",
  "icon-park-solid:shovel",
  "icon-park-solid:shovel-one",
  "icon-park-solid:shrimp",
  "icon-park-solid:snacks",
  "icon-park-solid:soybean-milk-maker",
  "icon-park-solid:spoon",
  "icon-park-solid:tea",
  "icon-park-solid:tea-drink",
  "icon-park-solid:teapot",
  "icon-park-solid:thermos-cup",
  "icon-park-solid:tomato",
  "icon-park-solid:tray",
  "icon-park-solid:turkey",
  "icon-park-solid:vegetable-basket",
  "icon-park-solid:vegetables",
  "icon-park-solid:vicia-faba",
  "icon-park-solid:watermelon",
  "icon-park-solid:watermelon-one",
  "icon-park-solid:arithmetic-buttons",
  "icon-park-solid:arrow-keys",
  "icon-park-solid:block-eight",
  "icon-park-solid:block-five",
  "icon-park-solid:block-four",
  "icon-park-solid:block-nine",
  "icon-park-solid:block-one",
  "icon-park-solid:block-seven",
  "icon-park-solid:block-six",
  "icon-park-solid:block-ten",
  "icon-park-solid:block-three",
  "icon-park-solid:block-two",
  "icon-park-solid:game",
  "icon-park-solid:game-handle",
  "icon-park-solid:game-ps",
  "icon-park-solid:ghost",
  "icon-park-solid:handheld",
  "icon-park-solid:handle-a",
  "icon-park-solid:handle-b",
  "icon-park-solid:handle-c",
  "icon-park-solid:handle-down",
  "icon-park-solid:handle-left",
  "icon-park-solid:handle-right",
  "icon-park-solid:handle-round",
  "icon-park-solid:handle-square",
  "icon-park-solid:handle-triangle",
  "icon-park-solid:handle-up",
  "icon-park-solid:handle-x",
  "icon-park-solid:handle-y",
  "icon-park-solid:handle-z",
  "icon-park-solid:joystick",
  "icon-park-solid:nintendo-switch",
  "icon-park-solid:poker",
  "icon-park-solid:puzzle",
  "icon-park-solid:skull",
  "icon-park-solid:trophy",
  "icon-park-solid:diamond-one",
  "icon-park-solid:diamond-three",
  "icon-park-solid:diamond-two",
  "icon-park-solid:hexagon-one",
  "icon-park-solid:octagon",
  "icon-park-solid:oval-one",
  "icon-park-solid:parallelogram",
  "icon-park-solid:pentagon-one",
  "icon-park-solid:quadrilateral",
  "icon-park-solid:rectangle",
  "icon-park-solid:rectangle-one",
  "icon-park-solid:rectangle-small",
  "icon-park-solid:right-angle",
  "icon-park-solid:round",
  "icon-park-solid:square",
  "icon-park-solid:square-small",
  "icon-park-solid:trapezoid",
  "icon-park-solid:triangle",
  "icon-park-solid:bad",
  "icon-park-solid:bad-one",
  "icon-park-solid:bad-two",
  "icon-park-solid:come",
  "icon-park-solid:concept-sharing",
  "icon-park-solid:cool",
  "icon-park-solid:delivery",
  "icon-park-solid:easy",
  "icon-park-solid:fist",
  "icon-park-solid:five",
  "icon-park-solid:five-five",
  "icon-park-solid:four",
  "icon-park-solid:four-four",
  "icon-park-solid:good",
  "icon-park-solid:good-one",
  "icon-park-solid:good-two",
  "icon-park-solid:hand-down",
  "icon-park-solid:hand-left",
  "icon-park-solid:hand-right",
  "icon-park-solid:hand-up",
  "icon-park-solid:hi",
  "icon-park-solid:hold-interface",
  "icon-park-solid:hold-seeds",
  "icon-park-solid:move",
  "icon-park-solid:one",
  "icon-park-solid:one-one",
  "icon-park-solid:palm",
  "icon-park-solid:point",
  "icon-park-solid:point-out",
  "icon-park-solid:press",
  "icon-park-solid:reload",
  "icon-park-solid:rock-gesture",
  "icon-park-solid:six",
  "icon-park-solid:swing",
  "icon-park-solid:three",
  "icon-park-solid:three-three",
  "icon-park-solid:thumbs-down",
  "icon-park-solid:thumbs-up",
  "icon-park-solid:turn-on",
  "icon-park-solid:two",
  "icon-park-solid:two-two",
  "icon-park-solid:yep",
  "icon-park-solid:zoom",
  "icon-park-solid:air-conditioning",
  "icon-park-solid:airplay",
  "icon-park-solid:asterisk-key",
  "icon-park-solid:battery-failure",
  "icon-park-solid:battery-storage",
  "icon-park-solid:battery-tips",
  "icon-park-solid:battery-working-one",
  "icon-park-solid:bike",
  "icon-park-solid:bolt-one",
  "icon-park-solid:broadcast-radio",
  "icon-park-solid:bus",
  "icon-park-solid:calculator",
  "icon-park-solid:calculator-one",
  "icon-park-solid:camera-five",
  "icon-park-solid:camera-four",
  "icon-park-solid:camera-one",
  "icon-park-solid:camera-three",
  "icon-park-solid:camera-two",
  "icon-park-solid:car",
  "icon-park-solid:cd",
  "icon-park-solid:charging-treasure",
  "icon-park-solid:chip",
  "icon-park-solid:cloud-storage",
  "icon-park-solid:code-laptop",
  "icon-park-solid:collect-computer",
  "icon-park-solid:collect-laptop",
  "icon-park-solid:computer",
  "icon-park-solid:control",
  "icon-park-solid:cpu",
  "icon-park-solid:cup",
  "icon-park-solid:dashboard-one",
  "icon-park-solid:data-server",
  "icon-park-solid:delete-key",
  "icon-park-solid:desk-lamp",
  "icon-park-solid:devices",
  "icon-park-solid:digital-watches",
  "icon-park-solid:disabled-laptop",
  "icon-park-solid:disk",
  "icon-park-solid:disk-one",
  "icon-park-solid:disk-two",
  "icon-park-solid:dome-light",
  "icon-park-solid:download-laptop",
  "icon-park-solid:drone",
  "icon-park-solid:drone-one",
  "icon-park-solid:dvi",
  "icon-park-solid:eight-key",
  "icon-park-solid:electric-iron",
  "icon-park-solid:electronic-door-lock",
  "icon-park-solid:electronic-locks-close",
  "icon-park-solid:electronic-locks-open",
  "icon-park-solid:electronic-pen",
  "icon-park-solid:enter-key",
  "icon-park-solid:enter-key-one",
  "icon-park-solid:ethernet-off",
  "icon-park-solid:ethernet-on",
  "icon-park-solid:f-eight-key",
  "icon-park-solid:f-five-key",
  "icon-park-solid:f-four-key",
  "icon-park-solid:f-n-key",
  "icon-park-solid:f-nine-key",
  "icon-park-solid:f-one-key",
  "icon-park-solid:f-seven-key",
  "icon-park-solid:f-six-key",
  "icon-park-solid:f-three-key",
  "icon-park-solid:f-two-key",
  "icon-park-solid:f-zero-key",
  "icon-park-solid:five-key",
  "icon-park-solid:flashlight",
  "icon-park-solid:four-key",
  "icon-park-solid:game-console",
  "icon-park-solid:game-console-one",
  "icon-park-solid:game-three",
  "icon-park-solid:gamepad",
  "icon-park-solid:gopro",
  "icon-park-solid:hair-dryer-one",
  "icon-park-solid:hand-painted-plate",
  "icon-park-solid:hard-disk",
  "icon-park-solid:hard-disk-one",
  "icon-park-solid:hashtag-key",
  "icon-park-solid:hdd",
  "icon-park-solid:hdmi-cable",
  "icon-park-solid:hdmi-connector",
  "icon-park-solid:headset-two",
  "icon-park-solid:hunting-gear",
  "icon-park-solid:i-mac",
  "icon-park-solid:induction-lock",
  "icon-park-solid:intercom",
  "icon-park-solid:ipad",
  "icon-park-solid:ipad-one",
  "icon-park-solid:iphone",
  "icon-park-solid:iwatch-one",
  "icon-park-solid:iwatch-two",
  "icon-park-solid:kettle",
  "icon-park-solid:keyboard",
  "icon-park-solid:lamp",
  "icon-park-solid:laptop",
  "icon-park-solid:laptop-computer",
  "icon-park-solid:laptop-one",
  "icon-park-solid:locking-computer",
  "icon-park-solid:locking-laptop",
  "icon-park-solid:mac-finder",
  "icon-park-solid:master",
  "icon-park-solid:memory-card",
  "icon-park-solid:memory-card-one",
  "icon-park-solid:memory-one",
  "icon-park-solid:micro-sd",
  "icon-park-solid:micro-slr-camera",
  "icon-park-solid:microphone-one",
  "icon-park-solid:microscope-one",
  "icon-park-solid:microwave-oven",
  "icon-park-solid:mini-sd-card",
  "icon-park-solid:monitor-camera",
  "icon-park-solid:monitor-one",
  "icon-park-solid:mouse",
  "icon-park-solid:mouse-one",
  "icon-park-solid:multi-function-knife",
  "icon-park-solid:network-drive",
  "icon-park-solid:new-computer",
  "icon-park-solid:nine-key",
  "icon-park-solid:one-key",
  "icon-park-solid:pad",
  "icon-park-solid:painted-screen",
  "icon-park-solid:phone",
  "icon-park-solid:phone-one",
  "icon-park-solid:phonograph",
  "icon-park-solid:plug",
  "icon-park-solid:plug-one",
  "icon-park-solid:power-supply",
  "icon-park-solid:power-supply-one",
  "icon-park-solid:printer",
  "icon-park-solid:printer-two",
  "icon-park-solid:projector",
  "icon-park-solid:projector-one",
  "icon-park-solid:projector-three",
  "icon-park-solid:projector-two",
  "icon-park-solid:radio",
  "icon-park-solid:radio-one",
  "icon-park-solid:receiver",
  "icon-park-solid:record-player",
  "icon-park-solid:remote-control",
  "icon-park-solid:remote-control-one",
  "icon-park-solid:robot",
  "icon-park-solid:robot-one",
  "icon-park-solid:rocket-one",
  "icon-park-solid:round-socket",
  "icon-park-solid:router",
  "icon-park-solid:router-one",
  "icon-park-solid:rs-male",
  "icon-park-solid:sd",
  "icon-park-solid:sd-card",
  "icon-park-solid:seal",
  "icon-park-solid:server",
  "icon-park-solid:setting-computer",
  "icon-park-solid:setting-laptop",
  "icon-park-solid:seven-key",
  "icon-park-solid:shaver",
  "icon-park-solid:signal-tower",
  "icon-park-solid:sim",
  "icon-park-solid:sim-card",
  "icon-park-solid:six-key",
  "icon-park-solid:slave",
  "icon-park-solid:solid-state-disk",
  "icon-park-solid:sound",
  "icon-park-solid:sound-one",
  "icon-park-solid:speaker",
  "icon-park-solid:speaker-one",
  "icon-park-solid:ssd",
  "icon-park-solid:stapler",
  "icon-park-solid:stereo-one",
  "icon-park-solid:storage-card-one",
  "icon-park-solid:storage-card-two",
  "icon-park-solid:strongbox",
  "icon-park-solid:subway",
  "icon-park-solid:surveillance-cameras",
  "icon-park-solid:surveillance-cameras-one",
  "icon-park-solid:surveillance-cameras-two",
  "icon-park-solid:switch-nintendo",
  "icon-park-solid:switch-one",
  "icon-park-solid:table-lamp",
  "icon-park-solid:telescope",
  "icon-park-solid:three-key",
  "icon-park-solid:thunderbolt",
  "icon-park-solid:timer",
  "icon-park-solid:toilet",
  "icon-park-solid:transporter",
  "icon-park-solid:trumpet",
  "icon-park-solid:tv-one",
  "icon-park-solid:two-key",
  "icon-park-solid:type-drive",
  "icon-park-solid:u-disk",
  "icon-park-solid:upload-laptop",
  "icon-park-solid:usb",
  "icon-park-solid:usb-memory-stick",
  "icon-park-solid:usb-micro-one",
  "icon-park-solid:usb-micro-two",
  "icon-park-solid:usb-one",
  "icon-park-solid:usb-type-c",
  "icon-park-solid:vacuum-cleaner",
  "icon-park-solid:videocamera",
  "icon-park-solid:videocamera-one",
  "icon-park-solid:virtual-reality-glasses",
  "icon-park-solid:vr-glasses",
  "icon-park-solid:washing-machine",
  "icon-park-solid:washing-machine-one",
  "icon-park-solid:watch-one",
  "icon-park-solid:webcam",
  "icon-park-solid:zero-key",
  "icon-park-solid:ambulance",
  "icon-park-solid:anti-corrosion",
  "icon-park-solid:bottle",
  "icon-park-solid:brain",
  "icon-park-solid:cell",
  "icon-park-solid:composition",
  "icon-park-solid:cross-society",
  "icon-park-solid:endocrine",
  "icon-park-solid:eyes",
  "icon-park-solid:facial-mask",
  "icon-park-solid:first-aid-kit",
  "icon-park-solid:gauze",
  "icon-park-solid:general-branch",
  "icon-park-solid:germs",
  "icon-park-solid:hospital",
  "icon-park-solid:hospital-four",
  "icon-park-solid:hospital-three",
  "icon-park-solid:infusion",
  "icon-park-solid:injection",
  "icon-park-solid:love-and-help",
  "icon-park-solid:mask",
  "icon-park-solid:medical-box",
  "icon-park-solid:medical-files",
  "icon-park-solid:medical-mark",
  "icon-park-solid:medicine-bottle",
  "icon-park-solid:medicine-bottle-one",
  "icon-park-solid:medicine-chest",
  "icon-park-solid:microscope",
  "icon-park-solid:needle",
  "icon-park-solid:nests",
  "icon-park-solid:neural",
  "icon-park-solid:nmr",
  "icon-park-solid:nurse-cap",
  "icon-park-solid:nutrition",
  "icon-park-solid:orthopedic",
  "icon-park-solid:other",
  "icon-park-solid:panorama-horizontal",
  "icon-park-solid:pesticide",
  "icon-park-solid:pill",
  "icon-park-solid:pills",
  "icon-park-solid:prescription",
  "icon-park-solid:pure-natural",
  "icon-park-solid:red-cross",
  "icon-park-solid:safe-retrieval",
  "icon-park-solid:sperm",
  "icon-park-solid:stethoscope",
  "icon-park-solid:swallow",
  "icon-park-solid:teeth",
  "icon-park-solid:thermometer-one",
  "icon-park-solid:toxins",
  "icon-park-solid:traditional-chinese-medicine",
  "icon-park-solid:uterus",
  "icon-park-solid:weight",
  "icon-park-solid:electric-drill",
  "icon-park-solid:engineering-brand",
  "icon-park-solid:engineering-vehicle",
  "icon-park-solid:fire-extinguisher-one",
  "icon-park-solid:hammer-and-anvil",
  "icon-park-solid:heater-resistor",
  "icon-park-solid:helmet-one",
  "icon-park-solid:industrial-scales",
  "icon-park-solid:land-surveying",
  "icon-park-solid:led-diode",
  "icon-park-solid:oil-industry",
  "icon-park-solid:oscillator",
  "icon-park-solid:petrol",
  "icon-park-solid:potentiometer",
  "icon-park-solid:resistor",
  "icon-park-solid:robot-two",
  "icon-park-solid:scale-one",
  "icon-park-solid:screwdriver",
  "icon-park-solid:solar-energy-one",
  "icon-park-solid:spanner",
  "icon-park-solid:stack-light",
  "icon-park-solid:tape-measure",
  "icon-park-solid:wind-turbine",
  "icon-park-solid:worker",
  "icon-park-solid:beach-umbrella",
  "icon-park-solid:bedside",
  "icon-park-solid:bedside-two",
  "icon-park-solid:boiler",
  "icon-park-solid:coffee-machine",
  "icon-park-solid:cooking-pot",
  "icon-park-solid:door-handle",
  "icon-park-solid:double-bed",
  "icon-park-solid:hair-dryer",
  "icon-park-solid:hanger",
  "icon-park-solid:hanger-two",
  "icon-park-solid:hotel-do-not-clean",
  "icon-park-solid:hotel-please-clean",
  "icon-park-solid:iron",
  "icon-park-solid:iron-disable",
  "icon-park-solid:iron-three",
  "icon-park-solid:iron-two",
  "icon-park-solid:shower-head",
  "icon-park-solid:single-bed",
  "icon-park-solid:sofa",
  "icon-park-solid:sofa-two",
  "icon-park-solid:tub",
  "icon-park-solid:afro-pick",
  "icon-park-solid:barber-brush",
  "icon-park-solid:barber-clippers",
  "icon-park-solid:beauty-instrument",
  "icon-park-solid:blade",
  "icon-park-solid:conditioner",
  "icon-park-solid:cosmetic-brush",
  "icon-park-solid:english-mustache",
  "icon-park-solid:eyebrow",
  "icon-park-solid:face-powder",
  "icon-park-solid:facial-cleanser",
  "icon-park-solid:fingernail",
  "icon-park-solid:foundation-makeup",
  "icon-park-solid:hand-cream",
  "icon-park-solid:handwashing",
  "icon-park-solid:handwashing-fluid",
  "icon-park-solid:health-products",
  "icon-park-solid:jewelry",
  "icon-park-solid:lip-gloss",
  "icon-park-solid:lip-tattoo",
  "icon-park-solid:lipstick",
  "icon-park-solid:lipstick-one",
  "icon-park-solid:lotion",
  "icon-park-solid:makeups",
  "icon-park-solid:mascara",
  "icon-park-solid:massage-chair",
  "icon-park-solid:massage-chair-one",
  "icon-park-solid:massage-table",
  "icon-park-solid:mirror",
  "icon-park-solid:mirror-two",
  "icon-park-solid:nail-polish",
  "icon-park-solid:nail-polish-one",
  "icon-park-solid:paint",
  "icon-park-solid:perfumer-bottle",
  "icon-park-solid:razor",
  "icon-park-solid:reel",
  "icon-park-solid:scissors",
  "icon-park-solid:shaver-one",
  "icon-park-solid:shaving",
  "icon-park-solid:soap-bubble",
  "icon-park-solid:spa-candle",
  "icon-park-solid:straight-razor",
  "icon-park-solid:color-card",
  "icon-park-solid:compass",
  "icon-park-solid:cuvette",
  "icon-park-solid:experiment",
  "icon-park-solid:experiment-one",
  "icon-park-solid:flask",
  "icon-park-solid:ruler-one",
  "icon-park-solid:test-tube",
  "icon-park-solid:thermometer",
  "icon-park-solid:triangle-ruler",
  "icon-park-solid:vial",
  "icon-park-solid:add-subtract",
  "icon-park-solid:bank-card",
  "icon-park-solid:bank-card-one",
  "icon-park-solid:bank-card-two",
  "icon-park-solid:bank-transfer",
  "icon-park-solid:blockchain",
  "icon-park-solid:buy",
  "icon-park-solid:commodity",
  "icon-park-solid:consume",
  "icon-park-solid:coupon",
  "icon-park-solid:discovery-index",
  "icon-park-solid:exchange-four",
  "icon-park-solid:exchange-one",
  "icon-park-solid:exchange-three",
  "icon-park-solid:exchange-two",
  "icon-park-solid:finance",
  "icon-park-solid:financing",
  "icon-park-solid:financing-one",
  "icon-park-solid:financing-two",
  "icon-park-solid:flash-payment",
  "icon-park-solid:gift",
  "icon-park-solid:gift-bag",
  "icon-park-solid:gift-box",
  "icon-park-solid:history-query",
  "icon-park-solid:insert-card",
  "icon-park-solid:ipo",
  "icon-park-solid:mall-bag",
  "icon-park-solid:medication-time",
  "icon-park-solid:open-an-account",
  "icon-park-solid:optional",
  "icon-park-solid:paper-money",
  "icon-park-solid:pay-code-one",
  "icon-park-solid:red-envelope",
  "icon-park-solid:red-envelopes",
  "icon-park-solid:shopping",
  "icon-park-solid:shopping-bag",
  "icon-park-solid:shopping-bag-one",
  "icon-park-solid:shopping-cart",
  "icon-park-solid:shopping-cart-add",
  "icon-park-solid:shopping-cart-del",
  "icon-park-solid:shopping-cart-two",
  "icon-park-solid:shoulder-bag",
  "icon-park-solid:stock-market",
  "icon-park-solid:transaction",
  "icon-park-solid:transaction-order",
  "icon-park-solid:trend",
  "icon-park-solid:trend-two",
  "icon-park-solid:two-dimensional-code",
  "icon-park-solid:two-dimensional-code-one",
  "icon-park-solid:two-dimensional-code-two",
  "icon-park-solid:wallet",
  "icon-park-solid:wallet-one",
  "icon-park-solid:wallet-three",
  "icon-park-solid:wallet-two",
  "icon-park-solid:water-level",
  "icon-park-solid:water-rate",
  "icon-park-solid:water-rate-two",
  "icon-park-solid:weixin-market",
  "icon-park-solid:workbench",
  "icon-park-solid:add-music",
  "icon-park-solid:airpods",
  "icon-park-solid:bell-ring",
  "icon-park-solid:carousel-video",
  "icon-park-solid:collection-records",
  "icon-park-solid:concern",
  "icon-park-solid:entertainment",
  "icon-park-solid:fm",
  "icon-park-solid:headphone-sound",
  "icon-park-solid:headset",
  "icon-park-solid:headset-one",
  "icon-park-solid:monitor",
  "icon-park-solid:movie",
  "icon-park-solid:movie-board",
  "icon-park-solid:music",
  "icon-park-solid:music-cd",
  "icon-park-solid:music-list",
  "icon-park-solid:music-one",
  "icon-park-solid:mute",
  "icon-park-solid:pause-one",
  "icon-park-solid:performance",
  "icon-park-solid:piano",
  "icon-park-solid:play",
  "icon-park-solid:play-one",
  "icon-park-solid:play-wrong",
  "icon-park-solid:playback-progress",
  "icon-park-solid:ppt",
  "icon-park-solid:record",
  "icon-park-solid:record-disc",
  "icon-park-solid:remind",
  "icon-park-solid:remind-disable",
  "icon-park-solid:replay-music",
  "icon-park-solid:signal-strength",
  "icon-park-solid:tape",
  "icon-park-solid:video",
  "icon-park-solid:voice",
  "icon-park-solid:voice-one",
  "icon-park-solid:voicemail",
  "icon-park-solid:volume-down",
  "icon-park-solid:volume-mute",
  "icon-park-solid:volume-notice",
  "icon-park-solid:volume-small",
  "icon-park-solid:volume-up",
  "icon-park-solid:abnormal",
  "icon-park-solid:add-print",
  "icon-park-solid:add-web",
  "icon-park-solid:agreement",
  "icon-park-solid:announcement",
  "icon-park-solid:audio-file",
  "icon-park-solid:book",
  "icon-park-solid:book-one",
  "icon-park-solid:book-open",
  "icon-park-solid:bookshelf",
  "icon-park-solid:box",
  "icon-park-solid:chinese",
  "icon-park-solid:chinese-one",
  "icon-park-solid:clipboard",
  "icon-park-solid:collect-picture",
  "icon-park-solid:collection-files",
  "icon-park-solid:compression",
  "icon-park-solid:copy-one",
  "icon-park-solid:data-file",
  "icon-park-solid:disabaled-web",
  "icon-park-solid:doc-add",
  "icon-park-solid:doc-detail",
  "icon-park-solid:doc-fail",
  "icon-park-solid:doc-search",
  "icon-park-solid:doc-search-two",
  "icon-park-solid:doc-success",
  "icon-park-solid:document-folder",
  "icon-park-solid:download-web",
  "icon-park-solid:email-block",
  "icon-park-solid:email-delect",
  "icon-park-solid:email-lock",
  "icon-park-solid:email-search",
  "icon-park-solid:email-security",
  "icon-park-solid:english",
  "icon-park-solid:excel",
  "icon-park-solid:file-addition",
  "icon-park-solid:file-cabinet",
  "icon-park-solid:file-code",
  "icon-park-solid:file-collection",
  "icon-park-solid:file-collection-one",
  "icon-park-solid:file-conversion",
  "icon-park-solid:file-date",
  "icon-park-solid:file-date-one",
  "icon-park-solid:file-display",
  "icon-park-solid:file-display-one",
  "icon-park-solid:file-editing",
  "icon-park-solid:file-editing-one",
  "icon-park-solid:file-excel",
  "icon-park-solid:file-failed",
  "icon-park-solid:file-focus",
  "icon-park-solid:file-focus-one",
  "icon-park-solid:file-gif",
  "icon-park-solid:file-hash",
  "icon-park-solid:file-hiding",
  "icon-park-solid:file-jpg",
  "icon-park-solid:file-lock",
  "icon-park-solid:file-lock-one",
  "icon-park-solid:file-music",
  "icon-park-solid:file-music-one",
  "icon-park-solid:file-pdf",
  "icon-park-solid:file-protection",
  "icon-park-solid:file-protection-one",
  "icon-park-solid:file-quality",
  "icon-park-solid:file-quality-one",
  "icon-park-solid:file-question",
  "icon-park-solid:file-removal",
  "icon-park-solid:file-search",
  "icon-park-solid:file-search-one",
  "icon-park-solid:file-search-two",
  "icon-park-solid:file-settings",
  "icon-park-solid:file-settings-one",
  "icon-park-solid:file-staff",
  "icon-park-solid:file-staff-one",
  "icon-park-solid:file-success",
  "icon-park-solid:file-text",
  "icon-park-solid:file-tips",
  "icon-park-solid:file-txt",
  "icon-park-solid:file-withdrawal",
  "icon-park-solid:file-word",
  "icon-park-solid:folder",
  "icon-park-solid:folder-block",
  "icon-park-solid:folder-block-one",
  "icon-park-solid:folder-close",
  "icon-park-solid:folder-code",
  "icon-park-solid:folder-conversion",
  "icon-park-solid:folder-download",
  "icon-park-solid:folder-failed",
  "icon-park-solid:folder-focus",
  "icon-park-solid:folder-focus-one",
  "icon-park-solid:folder-lock",
  "icon-park-solid:folder-lock-one",
  "icon-park-solid:folder-minus",
  "icon-park-solid:folder-music",
  "icon-park-solid:folder-music-one",
  "icon-park-solid:folder-open",
  "icon-park-solid:folder-plus",
  "icon-park-solid:folder-protection",
  "icon-park-solid:folder-protection-one",
  "icon-park-solid:folder-quality",
  "icon-park-solid:folder-quality-one",
  "icon-park-solid:folder-search",
  "icon-park-solid:folder-search-one",
  "icon-park-solid:folder-settings",
  "icon-park-solid:folder-settings-one",
  "icon-park-solid:folder-success",
  "icon-park-solid:folder-upload",
  "icon-park-solid:folder-withdrawal",
  "icon-park-solid:font-search",
  "icon-park-solid:format",
  "icon-park-solid:healthy-recognition",
  "icon-park-solid:image-files",
  "icon-park-solid:inbox",
  "icon-park-solid:inbox-download-r",
  "icon-park-solid:inbox-in",
  "icon-park-solid:inbox-out",
  "icon-park-solid:inbox-r",
  "icon-park-solid:inbox-success",
  "icon-park-solid:inbox-success-r",
  "icon-park-solid:inbox-upload-r",
  "icon-park-solid:inspection",
  "icon-park-solid:instruction",
  "icon-park-solid:invalid-files",
  "icon-park-solid:label",
  "icon-park-solid:level",
  "icon-park-solid:locking-picture",
  "icon-park-solid:locking-web",
  "icon-park-solid:log",
  "icon-park-solid:mail",
  "icon-park-solid:mail-download",
  "icon-park-solid:mail-edit",
  "icon-park-solid:mail-open",
  "icon-park-solid:mail-review",
  "icon-park-solid:mail-unpacking",
  "icon-park-solid:market-analysis",
  "icon-park-solid:new-picture",
  "icon-park-solid:newspaper-folding",
  "icon-park-solid:notebook",
  "icon-park-solid:notebook-and-pen",
  "icon-park-solid:notebook-one",
  "icon-park-solid:notepad",
  "icon-park-solid:notes",
  "icon-park-solid:optimize",
  "icon-park-solid:order",
  "icon-park-solid:permissions",
  "icon-park-solid:picture",
  "icon-park-solid:picture-album",
  "icon-park-solid:play-two",
  "icon-park-solid:receive",
  "icon-park-solid:schedule",
  "icon-park-solid:seo-folder",
  "icon-park-solid:setting-web",
  "icon-park-solid:source-code",
  "icon-park-solid:table",
  "icon-park-solid:termination-file",
  "icon-park-solid:text-message",
  "icon-park-solid:ticket",
  "icon-park-solid:ticket-one",
  "icon-park-solid:timed-mail",
  "icon-park-solid:transform",
  "icon-park-solid:upload-web",
  "icon-park-solid:video-conference",
  "icon-park-solid:video-file",
  "icon-park-solid:video-one",
  "icon-park-solid:view-list",
  "icon-park-solid:web-page",
  "icon-park-solid:beauty",
  "icon-park-solid:click",
  "icon-park-solid:color-filter",
  "icon-park-solid:contrast",
  "icon-park-solid:contrast-view",
  "icon-park-solid:contrast-view-circle",
  "icon-park-solid:effects",
  "icon-park-solid:erase",
  "icon-park-solid:figma-mask",
  "icon-park-solid:fill",
  "icon-park-solid:flip-camera",
  "icon-park-solid:game-two",
  "icon-park-solid:magnet",
  "icon-park-solid:mask-one",
  "icon-park-solid:material",
  "icon-park-solid:material-two",
  "icon-park-solid:mirror-one",
  "icon-park-solid:pic-one",
  "icon-park-solid:scan-setting",
  "icon-park-solid:screen-rotation",
  "icon-park-solid:stickers",
  "icon-park-solid:audit",
  "icon-park-solid:balance",
  "icon-park-solid:blackboard",
  "icon-park-solid:bookmark-three",
  "icon-park-solid:broadcast",
  "icon-park-solid:browser",
  "icon-park-solid:bytedance-mini-app",
  "icon-park-solid:card-two",
  "icon-park-solid:certificate",
  "icon-park-solid:creative",
  "icon-park-solid:crown",
  "icon-park-solid:dashboard-car",
  "icon-park-solid:degree-hat",
  "icon-park-solid:desk-lamp-one",
  "icon-park-solid:energy-socket",
  "icon-park-solid:express-delivery",
  "icon-park-solid:fireworks",
  "icon-park-solid:folder-one",
  "icon-park-solid:full-screen-play",
  "icon-park-solid:gas",
  "icon-park-solid:gavel",
  "icon-park-solid:glasses-three",
  "icon-park-solid:id-card",
  "icon-park-solid:light-member",
  "icon-park-solid:medal-one",
  "icon-park-solid:pay-code",
  "icon-park-solid:read-book",
  "icon-park-solid:seat",
  "icon-park-solid:shake",
  "icon-park-solid:sickbed",
  "icon-park-solid:sleep-two",
  "icon-park-solid:snowman",
  "icon-park-solid:stand-up",
  "icon-park-solid:terminal",
  "icon-park-solid:thinking-problem",
  "icon-park-solid:toolkit",
  "icon-park-solid:trace",
  "icon-park-solid:vip-one",
  "icon-park-solid:voice-input",
  "icon-park-solid:voice-message",
  "icon-park-solid:weixin-cards-offers",
  "icon-park-solid:weixin-mini-app",
  "icon-park-solid:weixin-scan",
  "icon-park-solid:weixin-shake",
  "icon-park-solid:weixin-top-stories",
  "icon-park-solid:add-user",
  "icon-park-solid:address-book",
  "icon-park-solid:appointment",
  "icon-park-solid:avatar",
  "icon-park-solid:baby",
  "icon-park-solid:classroom",
  "icon-park-solid:edit-name",
  "icon-park-solid:every-user",
  "icon-park-solid:hands",
  "icon-park-solid:id-card-h",
  "icon-park-solid:id-card-v",
  "icon-park-solid:me",
  "icon-park-solid:passport",
  "icon-park-solid:people",
  "icon-park-solid:people-bottom",
  "icon-park-solid:people-bottom-card",
  "icon-park-solid:people-delete",
  "icon-park-solid:people-delete-one",
  "icon-park-solid:people-download",
  "icon-park-solid:people-left",
  "icon-park-solid:people-minus",
  "icon-park-solid:people-minus-one",
  "icon-park-solid:people-plus",
  "icon-park-solid:people-plus-one",
  "icon-park-solid:people-right",
  "icon-park-solid:people-safe",
  "icon-park-solid:people-safe-one",
  "icon-park-solid:people-search",
  "icon-park-solid:people-search-one",
  "icon-park-solid:people-speak",
  "icon-park-solid:people-top",
  "icon-park-solid:people-top-card",
  "icon-park-solid:people-unknown",
  "icon-park-solid:people-upload",
  "icon-park-solid:peoples",
  "icon-park-solid:peoples-two",
  "icon-park-solid:personal-collection",
  "icon-park-solid:personal-privacy",
  "icon-park-solid:public-toilet",
  "icon-park-solid:reduce-user",
  "icon-park-solid:right-user",
  "icon-park-solid:turn-around",
  "icon-park-solid:user",
  "icon-park-solid:user-business",
  "icon-park-solid:user-positioning",
  "icon-park-solid:user-to-user-transmission",
  "icon-park-solid:weixin-people-nearby",
  "icon-park-solid:women",
  "icon-park-solid:wrong-user",
  "icon-park-solid:alarm",
  "icon-park-solid:balance-two",
  "icon-park-solid:bug",
  "icon-park-solid:caution",
  "icon-park-solid:fire-extinguisher",
  "icon-park-solid:harm",
  "icon-park-solid:imbalance",
  "icon-park-solid:key",
  "icon-park-solid:keyhole",
  "icon-park-solid:protect",
  "icon-park-solid:protection",
  "icon-park-solid:radiation",
  "icon-park-solid:report",
  "icon-park-solid:shield",
  "icon-park-solid:shield-add",
  "icon-park-solid:umbrella",
  "icon-park-solid:umbrella-one",
  "icon-park-solid:umbrella-two",
  "icon-park-solid:air-bike",
  "icon-park-solid:archery",
  "icon-park-solid:arena",
  "icon-park-solid:badge-two",
  "icon-park-solid:badminton",
  "icon-park-solid:balance-one",
  "icon-park-solid:baokemeng",
  "icon-park-solid:baseball-bat",
  "icon-park-solid:basketball-one",
  "icon-park-solid:black-eight",
  "icon-park-solid:bottom-bar-one",
  "icon-park-solid:boxing",
  "icon-park-solid:checkerboard",
  "icon-park-solid:chess-one",
  "icon-park-solid:curling",
  "icon-park-solid:diving-bottle",
  "icon-park-solid:diving-suit",
  "icon-park-solid:five-star-badge",
  "icon-park-solid:gold-medal",
  "icon-park-solid:gold-medal-two",
  "icon-park-solid:golf-course",
  "icon-park-solid:gongfu",
  "icon-park-solid:gymnastics",
  "icon-park-solid:gymnastics-one",
  "icon-park-solid:helmet",
  "icon-park-solid:hockey",
  "icon-park-solid:jump",
  "icon-park-solid:kungfu",
  "icon-park-solid:muscle",
  "icon-park-solid:play-basketball",
  "icon-park-solid:play-volleyball",
  "icon-park-solid:riding",
  "icon-park-solid:rings",
  "icon-park-solid:rollerskates",
  "icon-park-solid:rope-skipping",
  "icon-park-solid:rowing",
  "icon-park-solid:sailboat",
  "icon-park-solid:scoreboard",
  "icon-park-solid:skate",
  "icon-park-solid:skating",
  "icon-park-solid:skiing-nordic",
  "icon-park-solid:soccer",
  "icon-park-solid:soccer-one",
  "icon-park-solid:spikedshoes",
  "icon-park-solid:spinning-top",
  "icon-park-solid:sport",
  "icon-park-solid:sporting",
  "icon-park-solid:stretching-one",
  "icon-park-solid:swimming-ring",
  "icon-park-solid:tabletennis",
  "icon-park-solid:target-one",
  "icon-park-solid:thin",
  "icon-park-solid:torch",
  "icon-park-solid:towel",
  "icon-park-solid:treadmill",
  "icon-park-solid:treadmill-one",
  "icon-park-solid:treadmill-two",
  "icon-park-solid:waterpolo-one",
  "icon-park-solid:weightlifting",
  "icon-park-solid:wingsuit-flying",
  "icon-park-solid:alarm-clock",
  "icon-park-solid:big-clock",
  "icon-park-solid:calendar-dot",
  "icon-park-solid:calendar-thirty",
  "icon-park-solid:calendar-thirty-two",
  "icon-park-solid:calendar-three",
  "icon-park-solid:iwatch",
  "icon-park-solid:loading-three",
  "icon-park-solid:radar-two",
  "icon-park-solid:speed",
  "icon-park-solid:speed-one",
  "icon-park-solid:stopwatch",
  "icon-park-solid:stopwatch-start",
  "icon-park-solid:time",
  "icon-park-solid:watch",
  "icon-park-solid:acceleration",
  "icon-park-solid:airplane",
  "icon-park-solid:airplane-window",
  "icon-park-solid:airplane-window-one",
  "icon-park-solid:anchor-two",
  "icon-park-solid:aviation",
  "icon-park-solid:baggage-delay",
  "icon-park-solid:brake-pads",
  "icon-park-solid:bus-one",
  "icon-park-solid:bus-two",
  "icon-park-solid:cable-car",
  "icon-park-solid:camp",
  "icon-park-solid:car-battery",
  "icon-park-solid:coconut-tree",
  "icon-park-solid:compass-one",
  "icon-park-solid:consignment",
  "icon-park-solid:cruise",
  "icon-park-solid:descend",
  "icon-park-solid:diving",
  "icon-park-solid:enquire",
  "icon-park-solid:flag",
  "icon-park-solid:flight-airflow",
  "icon-park-solid:flight-safety",
  "icon-park-solid:frigate",
  "icon-park-solid:gate-machine",
  "icon-park-solid:globe",
  "icon-park-solid:gps",
  "icon-park-solid:guide-board",
  "icon-park-solid:high-speed-rail",
  "icon-park-solid:homestay",
  "icon-park-solid:hot-air-balloon",
  "icon-park-solid:in-flight",
  "icon-park-solid:landing",
  "icon-park-solid:local",
  "icon-park-solid:local-pin",
  "icon-park-solid:local-two",
  "icon-park-solid:luggage",
  "icon-park-solid:manual-gear",
  "icon-park-solid:map-distance",
  "icon-park-solid:map-draw",
  "icon-park-solid:map-road",
  "icon-park-solid:map-road-two",
  "icon-park-solid:map-two",
  "icon-park-solid:mark",
  "icon-park-solid:mountain",
  "icon-park-solid:mounted",
  "icon-park-solid:navigation",
  "icon-park-solid:parachute",
  "icon-park-solid:parking",
  "icon-park-solid:passport-one",
  "icon-park-solid:pennant",
  "icon-park-solid:planet",
  "icon-park-solid:pyramid-one",
  "icon-park-solid:railway",
  "icon-park-solid:repositioning",
  "icon-park-solid:resting",
  "icon-park-solid:road-cone",
  "icon-park-solid:road-sign",
  "icon-park-solid:road-sign-both",
  "icon-park-solid:rocket",
  "icon-park-solid:round-trip",
  "icon-park-solid:sailboat-one",
  "icon-park-solid:sailing",
  "icon-park-solid:selfie",
  "icon-park-solid:set-off",
  "icon-park-solid:shade",
  "icon-park-solid:ship",
  "icon-park-solid:steering-wheel",
  "icon-park-solid:sunset",
  "icon-park-solid:take-off-one",
  "icon-park-solid:taxi",
  "icon-park-solid:tent",
  "icon-park-solid:tent-banner",
  "icon-park-solid:theater",
  "icon-park-solid:tickets-one",
  "icon-park-solid:tickets-two",
  "icon-park-solid:tour-bus",
  "icon-park-solid:train",
  "icon-park-solid:transfer",
  "icon-park-solid:transport",
  "icon-park-solid:universal",
  "icon-park-solid:vacation",
  "icon-park-solid:wheelchair",
  "icon-park-solid:cloudy",
  "icon-park-solid:cloudy-night",
  "icon-park-solid:moon",
  "icon-park-solid:sun",
  "icon-park-solid:sun-one",
  "icon-park-solid:thunderstorm-one"
];
